import api from '@/core/api/client';
import type { AssignmentPreview } from '@/features/plans';
import { companiesService, type Company } from './companies.service';

export interface MigrationPreview extends AssignmentPreview {
  oldPlanName: string; newPlanName: string; independentAmount: number; expectedTotalAmount: number;
  expectedSubscriptionId: string; expectedSubscriptionUpdatedAt: string;
}
export function migrationError(error: unknown) {
  const reason = (error as { response?: { data?: { errors?: { migrationReason?: string } } } })?.response?.data?.errors?.migrationReason;
  return ({ ALREADY_MIGRATED: 'Plano já migrado — não será alterado.', NO_ACTIVE_SUBSCRIPTION: 'Sem assinatura ativa — não será reativada.', EXISTING_INVOICE: 'Já existe fatura para este ciclo. Revise a cobrança individualmente.' } as Record<string, string>)[reason ?? ''];
}
export async function allMigrationCompanies(): Promise<Company[]> {
  const result: Company[] = [];
  for (let page = 1; ; page++) {
    const response = await companiesService.list({ page, limit: 100, status: 'ACTIVE', includeDeleted: false });
    result.push(...response.data);
    if (page >= response.pagination.totalPages) break;
  }
  return [...new Map(result.map((company) => [company.id, company])).values()];
}
export async function reviewCompanyMigration(companyId: string, input: { planId: string; seatCount?: number; additionalConnectionCount?: number }): Promise<MigrationPreview> {
  return (await api.post(`/companies/${companyId}/migration/preview`, input)).data.data;
}
export async function executeCompanyMigration(companyId: string, preview: MigrationPreview, requestKey: string) {
  return (await api.post(`/companies/${companyId}/migration`, {
    requestKey, planId: preview.planId, seatCount: preview.seatCount, additionalConnectionCount: preview.additionalConnectionCount,
    currency: preview.currency, expectedVersion: preview.expectedVersion, expectedPlanVersion: preview.expectedPlanVersion,
    expectedUnitAmount: preview.unitAmount, expectedInterval: preview.interval, expectedConnectionType: preview.pricingConnectionType,
    expectedSubscriptionId: preview.expectedSubscriptionId, expectedSubscriptionUpdatedAt: preview.expectedSubscriptionUpdatedAt,
    expectedTotalAmount: preview.expectedTotalAmount, noExternalCharges: true,
  })).data.data as { subscriptionId: string; invoiceId: string | null };
}
